import { ReactNode } from 'react';

export type FormInputWrapperProps = {
  /**
   * 48
   * 80 - krótkie wartości liczbowe, np. nr budynku
   * 100 - np. unit selector
   * 120 - np. pln
   * 156 - jeden dzień pole daty
   * 180 - short text
   * 200 - krótkie hasła, np. wybór jednostki
   * 224 - lista wybierana w modalu
   * 320 - default, np. nazwy własne, ale być zakres dat (najczęstszy)
   * 400
   * 560 - opisy, dłuższe wartości, np. notatka
   * 720
   */
  readonly maxWidth: 1 | 48 | 80 | 100 | 120 | 156 | 180 | 224 | 320 | 400 | 560 | 720;
  readonly fullWidth?: boolean;
  readonly children: ReactNode;
};

const MAX_WIDTH_CLASS: Record<FormInputWrapperProps['maxWidth'], string> = {
  1: 'sm:max-w-full',
  48: 'sm:max-w-[48px]',
  80: 'sm:max-w-[80px]',
  100: 'sm:max-w-[100px]',
  120: 'sm:max-w-[120px]',
  156: 'sm:max-w-[156px]',
  180: 'sm:max-w-[180px]',
  224: 'sm:max-w-[224px]',
  320: 'sm:max-w-[320px]',
  400: 'sm:max-w-[400px]',
  560: 'sm:max-w-[560px]',
  720: 'sm:max-w-[720px]',
};

export const FormInputWrapper = ({ maxWidth, fullWidth, children }: FormInputWrapperProps) => (
  <div className={`max-w-full ${MAX_WIDTH_CLASS[maxWidth]} ${fullWidth ? 'w-full' : ''}`}>{children}</div>
);
FormInputWrapper.displayName = 'FormInputWrapper';
